import React from 'react';
import {connect} from 'react-redux';

import {ContextProvider} from '../../components/ContextProvider/ContextProvider';
import TermsPageContent from './TermsPageContent';

export const TermsPage = () => {
  return (
    <div>
      <TermsPageContent />
    </div>
  );
};

const mapStateToProps = state => {
  return {
    language: state.language
  };
};

export default connect(mapStateToProps)(ContextProvider(TermsPage));



// WEBPACK FOOTER //
// ./containers/TermsPage/TermsPage.js